import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import "./BankDetails.css";
import { Link } from "react-router-dom";
import Table from "react-bootstrap/Table";
import { Context } from "../../../../utils/context";
import { Permission } from "../../../../utils/permissions";
import { deleteData, editStatusData } from "../../../../utils/api";
import plus from "../../assets/icons/a1.png";
import search1 from "../../assets/icons/search.png";
import AddOffCanvance from "./Add";
import ModalDelete from "../../../common/ModalDelete";
import Pagination from "../../../common/Pagination";
import { EditButton, DeletButton } from "../../../common/Button";

const PER_PAGE_OPTIONS = [5, 10, 25, 50, 100];

const BankDetails = () => {
  const { getData, isAllow, ErrorNotify } = useContext(Context);
  const canAdd = isAllow?.includes(Permission.BankDetail.Add.name);
  const canEdit = isAllow?.includes(Permission.BankDetail.Edit.name);
  const canDelete = isAllow?.includes(Permission.BankDetail.Delete.name);

  const [banks, setBanks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  // `search` is what is typed, `appliedSearch` is what the list is filtered by
  const [search, setSearch] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const [refresh, setRefresh] = useState(0);

  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const [deleteTarget, setDeleteTarget] = useState(null);

  const reload = () => setRefresh((value) => value + 1);

  useEffect(() => {
    let ignore = false;

    const loadBanks = async () => {
      const response = await getData(
        `/masters/bank-detail?page=${currentPage}&per_page=${perPage}&term=${encodeURIComponent(appliedSearch)}`,
      );
      if (ignore) return;

      const result = response?.data;
      setBanks(result?.data || []);
      setTotalPages(result?.totalPages || 1);
      setTotalEntries(result?.totalEntries || 0);

      // e.g. the last bank of the last page was deleted
      if (result?.totalPages && currentPage > result.totalPages) {
        setCurrentPage(result.totalPages);
      }
    };

    loadBanks();
    return () => {
      ignore = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, perPage, appliedSearch, refresh]);

  const handleSearch = () => {
    setCurrentPage(1);
    setAppliedSearch(search.trim());
  };

  const handleReset = () => {
    setSearch("");
    setAppliedSearch("");
    setCurrentPage(1);
  };

  const handlePerPage = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const ChangeStatus = async (id) => {
    await editStatusData(`/masters/bank-detail/${id}`);
    reload();
  };

  const handleSorting = async (position, id) => {
    if (!position) return;

    const response = await editStatusData(`/masters/bank-detail/sort/${id}`, {
      sort_order: position,
    });
    if (!response?.success) {
      alert(response?.message || "Unable to change the position");
    }
    reload();
  };

  const showDeleteRecord = (id, name) => setDeleteTarget({ id, name });

  const handleDeleteRecord = async () => {
    const target = deleteTarget;
    setDeleteTarget(null);
    if (!target) return;

    const response = await deleteData(`/masters/bank-detail/${target.id}`);
    if (response?.success) {
      ErrorNotify(target.name);
    } else {
      alert(response?.message || "Unable to delete the bank");
    }
    reload();
  };

  const handleShowForm = (id = null) => {
    setEditId(id);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditId(null);
    reload();
  };

  const rowName = (bank) =>
    bank?.bank_name || bank?.upi_id || bank?.network?.name || "Bank";

  return (
    <>
      <div className="bank_detail_card_holder">
        <div className="row">
          <div className="d-flex">
            <div className="add me-3">
              {canAdd && (
                <Link type="button" className="btn btn-add pe-3">
                  <div onClick={() => handleShowForm()}>
                    <img src={plus} className="plus me-2 ms-0" alt="" />
                    Add Bank Details
                  </div>
                </Link>
              )}
            </div>
          </div>
          <div className="border-line mt-3"></div>

          <div className="row mt-4">
            <div className="col-lg-4 col-md-4 col-12">
              <div className="d-flex">
                <div className="show me-2">
                  <p className="show mt-1">Show</p>
                </div>
                <div className="number me-2">
                  <select
                    className="form-select form-select-sm"
                    aria-label="Entries per page"
                    value={perPage}
                    onChange={handlePerPage}
                  >
                    {PER_PAGE_OPTIONS.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="entries">
                  <p className="show mt-1">entries</p>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-8 col-12">
              <div className="d-flex justify-content-end">
                <div className="num me-2">
                  <input
                    aria-label="Search"
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                  />
                </div>
                <div className="Search me-2">
                  <button
                    aria-label="Search"
                    type="button"
                    onClick={handleSearch}
                    className="btn btn-search"
                  >
                    <img src={search1} className="search" alt="" />
                  </button>
                </div>
                <div className="Search-1">
                  <button
                    type="button"
                    onClick={handleReset}
                    className="btn btn-reset"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-line mt-2"></div>
        <div className="row mt-3">
          <div className="data table-responsive">
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th className="sr">Sr. No.</th>
                  <th className="tax-name">Position</th>
                  <th className="tax-name">Payment Type</th>
                  <th className="tax-name">Account Name</th>
                  <th className="tax-name">Bank Name</th>
                  <th className="tax-name">A/c No</th>
                  <th className="tax-name">IFSC</th>
                  <th className="tax-name">Branch</th>
                  <th className="tax-name">UPI ID</th>
                  <th className="tax-name">Network</th>
                  {canEdit && <th className="tax-name">Status</th>}
                  <th className="active">Action</th>
                </tr>
              </thead>
              <tbody>
                {banks.length === 0 && (
                  <tr>
                    <td colSpan={12} className="text-center">
                      No banks found
                    </td>
                  </tr>
                )}
                {banks.map((item, index) => (
                  <tr key={item?.id}>
                    <td>{(currentPage - 1) * perPage + index + 1}.</td>
                    <td>
                      <select
                        className="form-select form-select-sm inner_select"
                        value={item?.sort_order || ""}
                        disabled={!canEdit}
                        onChange={(e) =>
                          handleSorting(parseInt(e.target.value), item?.id)
                        }
                      >
                        {!item?.sort_order && <option value="">-</option>}
                        {Array.from({ length: totalEntries }, (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>{item?.payment_type || "-"}</td>
                    <td>{item?.holder_name || "-"}</td>
                    <td>{item?.bank_name || "-"}</td>
                    <td>{item?.ac_no || "-"}</td>
                    <td>{item?.ifsc_code || "-"}</td>
                    <td>{item?.firm_name || "-"}</td>
                    <td>{item?.upi_id || "-"}</td>
                    <td>
                      {item?.network?.name
                        ? `${item.network.name}${
                            item.network.sub_name
                              ? ` (${item.network.sub_name})`
                              : ""
                          }`
                        : "-"}
                    </td>
                    {canEdit && (
                      <td>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            checked={!!item?.status}
                            onChange={() => ChangeStatus(item?.id)}
                            id={`bankStatus${item?.id}`}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`bankStatus${item?.id}`}
                          >
                            {item?.status ? "Active" : "Inactive"}
                          </label>
                        </div>
                      </td>
                    )}
                    <td>
                      <div className="d-flex">
                        {canEdit && (
                          <EditButton handleShow1={handleShowForm} id={item?.id} />
                        )}
                        {canDelete && (
                          <DeletButton
                            showDeleteRecord={showDeleteRecord}
                            id={item?.id}
                            name={rowName(item)}
                          />
                        )}
                        <Link to={`/bank-payments/${item?.id}`}>
                          <button type="button" className="btn btn-info ms-1">
                            View Payments
                          </button>
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            TotalPages={totalPages}
            TotalEntries={totalEntries}
            perPage={perPage}
          />
        </div>
      </div>

      {showForm ? (
        <AddOffCanvance
          handleClose={handleCloseForm}
          setShow={setShowForm}
          show={showForm}
          id={editId}
        />
      ) : (
        ""
      )}

      <ModalDelete
        show={!!deleteTarget}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={() => setDeleteTarget(null)}
      />
    </>
  );
};
export default BankDetails;
